var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FelaComponent } from '@filou/core';
var rule = function (_a) {
    var theme = _a.theme, _b = _a.level, level = _b === void 0 ? 0 : _b;
    return ({
        listStyleType: 'none',
        paddingLeft: 10 * level
    });
};
var ruleItem = function (_a) {
    var theme = _a.theme, hasChildren = _a.hasChildren;
    return ({
        color: theme.light,
        marginTop: hasChildren ? theme.space3 : undefined,
        '> a': {
            display: 'block',
            marginBottom: hasChildren ? theme.space2 : undefined,
            fontSize: hasChildren ? theme.fontSizeSmall : theme.fontSize,
            color: theme.light,
            textDecoration: 'none',
            onHover: {
                color: theme.light1
            }
        },
        marginBottom: hasChildren ? theme.space2 : undefined
    });
};
var Sitemap = /** @class */ (function (_super) {
    __extends(Sitemap, _super);
    function Sitemap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sitemap.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.level, level = _b === void 0 ? 0 : _b, className = _a.className;
        var arr = React.Children.toArray(children);
        return (React.createElement(FelaComponent, { rule: rule, level: level, className: className, render: function (_a) {
                var className = _a.className;
                return (React.createElement("ul", { className: className }, arr.map(function (child) {
                    return React.cloneElement(child, {
                        level: level
                    });
                })));
            } }));
    };
    Sitemap.Item = function (_a) {
        var children = _a.children, label = _a.label, _b = _a.level, level = _b === void 0 ? 0 : _b, className = _a.className;
        return (React.createElement(FelaComponent, { rule: ruleItem, className: className, hasChildren: !!React.Children.count(children), render: function (_a) {
                var className = _a.className;
                return (React.createElement("li", { className: className },
                    typeof label === 'string' ? (React.createElement("a", { href: "javascript:;" }, label)) : (label),
                    React.Children.count(children) ? (React.createElement(Sitemap, { level: level + 1 }, children)) : null));
            } }));
    };
    return Sitemap;
}(React.Component));
export default Sitemap;
//# sourceMappingURL=index.js.map